import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=7ccb3954&scoped=true"
import script from "./EmailHistory.vue?vue&type=script&lang=js"
export * from "./EmailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb3954",
  null
  
)

export default component.exports